import { OptionalPaginationQueryParams, Pagination } from "@CommonTypes/backend/pagination";

export const RouteGetInputsProductsAll = "/inputs/products/all";

export const PRODUCT_SORTABLE_COLUMNS = [
  "upc",
  "product_code",
  "name",
  "brand",
  "category",
  "subcategory",
] as const;

export type ProductSortableColumn = (typeof PRODUCT_SORTABLE_COLUMNS)[number];

export type ParamsGetInputsProductsAll = OptionalPaginationQueryParams & {
  upc?: string;
  product_code?: string;
  name?: string;
  brand?: string | string[];
  category?: string | string[];
  subcategory?: string | string[];
  sortBy?: ProductSortableColumn;
  sortDirection?: "asc" | "desc";
};

export type ResponseGetInputsProductsAll = Pagination<Product>;

export interface Product {
  product_id: number;
  upload_id: number | null;
  upc: string | null;
  /** external id for merchant use */
  product_code: string | null;
  name: string | null;
  size: string | null;
  /** Stated weight of one pack of each format; null where none is stated. */
  unit_weight: number | null;
  tray_weight: number | null;
  case_weight: number | null;
  /** Unit all three weights share: one of g, kg, oz, lb. */
  weight_uom: string | null;
  brand: string | null;
  category: string | null;
  subcategory: string | null;
  unit_width: number | null;
  unit_height: number | null;
  unit_depth: number | null;
  tray_width: number | null;
  tray_height: number | null;
  tray_depth: number | null;
  case_width: number | null;
  case_height: number | null;
  case_depth: number | null;
  display_height: number | null;
  display_width: number | null;
  display_depth: number | null;
  tray_number_wide: number | null;
  tray_number_deep: number | null;
  tray_number_high: number | null;
  tray_total_number: number | null;
  case_number_wide: number | null;
  case_number_deep: number | null;
  case_number_high: number | null;
  case_total_number: number | null;
  squeeze_width_pct: number | null;
  squeeze_height_pct: number | null;
  squeeze_depth_pct: number | null;
  color: string | null;
  /** desc4 from PSA */
  sub_commodity: string | null;
  /** desc9 from PSA */
  internal_comments: string | null;
  /** flag3 from PSA */
  is_disco_item: boolean | null;
  shape_id: string | null;
  manufacturer: string | null;
  category_id: number | null;
}
